/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  Varieties,
  VarietiesVariables,
  Varieties_organization_Organization_crops_OrganizationCropsWithVarieties_varieties_OrganizationVarieties_results_Variety as Variety,
} from './types/index.graphql'

export const VARIETIES = gql`
  query Varieties(
    $commercialExecutiveId: Int
    $seasonStartRange: DateTime
    $seasonEndRange: DateTime
    $regionId: Int
    $subregionId: Int
  ) {
    organization {
      crops(
        commercialExecutiveId: $commercialExecutiveId
        seasonStartRange: $seasonStartRange
        seasonEndRange: $seasonEndRange
        regionId: $regionId
        subregionId: $subregionId
      ) {
        id
        varieties {
          results {
            id
            locales {
              es
            }
          }
          withNoVarietyOption
        }
      }
    }
  }
`
